import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-info-mfa',
  templateUrl: './modal-info-mfa.component.html',
  styleUrls: ['./modal-info-mfa.component.scss']
})
export class ModalInfoMfaComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalInfoMfaComponent>,
    private router: Router,
  ) {}

  //cancel
  close() {
    this.dialogRef.close(false);
  }

  goToConfig() {
    this.dialogRef.close(false);
    this.router.navigate(['/mfa-configuracion']);
  }

  goToTutorial() {
    // abrir en nueva pestaña
    window.open('mfa-tutorial', '_blank');
  }

}
